module.exports = __webpack_public_path__ + "img/個人星盤.36d0786f.png";